export enum ReportGroups {
  Business,
  Betshop,
  Manager,
  Cashier,
  Partner,
  Game,
}